export function IconGenderMismatch({ onClick, className, color = '#000' }) {
    return (
        <svg height="24" width="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className}>
            <rect height="23" width="23" fill="#fff" rx="11.5" x="0.5" y="0.5"/>
            <rect height="23" width="23" rx="11.5" stroke={color} x="0.5" y="0.5"/>
            <rect height="11" width="3" fill={color} rx="1.5" stroke={color} x="10.5" y="3.5"/>
            <circle cx="12" cy="19" fill={color} r="1.5" stroke={color}/>
        </svg>
    )
}
